/* The header's 'A' Icon, links to home. */

import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import routes from 'sitewide-js/core_pre_webpack/routes';

const REDUCE_MARGIN_SIZE = 625; // px

const Link = styled.a`
  margin-right: 24px;
  cursor: pointer;
  height: 24px;
  width: 24px;

  @media (max-width: ${REDUCE_MARGIN_SIZE}px) {
    margin-right: 16px;
  }
`;

type Props = {
  style?: React.CSSProperties;
};

const AcademiaIcon = ({ style }: Props) => (
  <Link href={routes.home_url()} style={style}>
    <img src={$image_url('academia-logo-2021.svg')} />
  </Link>
);

export default AcademiaIcon;
